const settings = {
    environment: {
        CORE_API_GATEWAY_URL:'https://app.digitalpaysvcs.com',
        DEPLOYMENT_ENVIRONMENT: 'PRD',
        PAYPAL_CONNECT_BASE_URL: 'https://www.paypal.com/signin/authorize?flowEntry=static',
        PAYWALL_CDN_URL: 'https://paywall-cdn-prd.digitalpaysvcs.com',
        PERFORM_HEALTH_CHECK: false,
        SYSTEM_UNAVAILABLE_TITLE: 'PLEASE COME BACK',
        SYSTEM_UNAVAILABLE_MESSAGE: 'We are experiencing an unusually high payment volume. Please return in 24 hours to process your payment.',
        SYSTEM_UNDER_MAINTENANCE_TITLE: 'SCHEDULED MAINTENANCE -- PLEASE COME BACK',
        SYSTEM_UNDER_MAINTENANCE_MESSAGE: 'Our systems are currently down while we perform scheduled maintenance. Please check back shortly to process your payment.',
        SYSTEM_UNDER_MAINTENANCE: 'false'
    }
};

if(settings.environment.DEPLOYMENT_ENVIRONMENT.toLowerCase().trim() === 'prd'){
    // prevent logging on production
    if(window.console && window.console.log){
        window.console.log = () => {};
    }
}

export default settings;
